import React, { useState } from "react";
import axios from "axios";
import {
  Col,
  Row,
  Container,
  Card,
  Spinner,
  Button,
  OverlayTrigger,
  Tooltip,
  Form,
} from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { Loading } from "../Loading";

import { MdDelete } from "react-icons/md";

import {
  onDeletePipeline,
  onAddPipeline,
  setIsInvoiceSyncRulesSaved,
  onDeleteSelectedPipeline,
  onCheckAddPDF,
} from "../../store/slices/invoiceSlice";
import {
  setShowErrorModal,
  setShowSuccessModal,
} from "../../store/slices/preferenceSlice";
import { getUrl } from "../../helpers/getUrl";

import SetupFieldsDropdown from "../SetupFieldsDropdown";

import { useCmsHook } from "../../helpers/cmsHook";

function InvoiceSyncRules() {
  const { cmsInstance } = useCmsHook();

  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);

  // invoice states
  const {
    pipelinePreference,
    dealStagePreference,
    selectedPipelines,
    pipelines: { pipelines, loading: pipelinesLoading },
    dealStages: { dealStages },
    invoiceDropdownFields,
    invoicePreference,
    attachPDFToInvoice,
  } = useSelector((state) => state.invoice);

  return (
    <div className="sync-settings-setup-page">
      {pipelinesLoading || !cmsInstance ? (
        <Loading />
      ) : (
        <Container className="px-0">
          <Row>
            <Col>
              <Card
                className="sync-settings-card"
                style={{ marginTop: "29px" }}
              >
                <Card.Body className="sync-settings-card-body">
                  <div>
                    {cmsInstance &&
                      cmsInstance.showRichText(
                        "cmsContent.invoices.invoiceSyncRules.block1"
                      )}
                  </div>
                  {selectedPipelines.length > 0 && (
                    <div className="mt-3">
                      <p className="my-1 fortnox-card-heading">
                        <b>Selected Pipelines</b>
                      </p>
                      <div>
                        {selectedPipelines.map((item, index) => (
                          <div
                            key={index}
                            className="selected-pipeline-container my-2 p-3 d-flex flex-row justify-content-between"
                          >
                            <div className="d-flex flex-row flex-wrap">
                              <p className="me-3 mb-0">
                                <b>Pipeline: </b>
                                <span>{item.pipeline.name}</span>
                              </p>
                              <p className="me-3 mb-0">
                                <b>Deal Stage: </b>
                                <span>{item.dealStage.name}</span>
                              </p>
                              <p className="mb-0">
                                <b>Generate: </b>
                                <span>{item.generate.name}</span>
                              </p>
                            </div>
                            <button
                              onClick={() =>
                                dispatch(
                                  onDeletePipeline({
                                    index,
                                  })
                                )
                              }
                              className="pipeline-delete-button"
                            >
                              <MdDelete size={18} />
                            </button>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  <p className="mt-3 mb-1">
                    <b>Select a pipeline</b>
                  </p>
                  <div>
                    {pipelines && (
                      <Col sm={5} lg={3}>
                        <SetupFieldsDropdown
                          fieldsData={pipelines}
                          dropdownFor="pipelines"
                          selectedPreference={pipelinePreference}
                          dispatch={dispatch}
                          selectedPipelines={selectedPipelines}
                        />
                      </Col>
                    )}
                    {dealStages && pipelinePreference && (
                      <Col sm={5} lg={3}>
                        <SetupFieldsDropdown
                          fieldsData={dealStages}
                          dropdownFor="dealStages"
                          selectedPreference={dealStagePreference}
                          dispatch={dispatch}
                        />
                      </Col>
                    )}
                    {dealStagePreference && invoiceDropdownFields && (
                      <Col sm={5} lg={3}>
                        <SetupFieldsDropdown
                          fieldsData={invoiceDropdownFields}
                          dropdownFor="preferenceForCreation"
                          selectedPreference={invoicePreference}
                          dispatch={dispatch}
                        />
                      </Col>
                    )}
                  </div>
                  <div className="d-flex flex-row">
                    {!pipelinePreference ||
                    !dealStagePreference ||
                    !invoicePreference ? (
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip style={{ fontSize: "12px" }}>
                            Please select the pipeline, dealStage and preference
                            for creation of Order/Invoice
                          </Tooltip>
                        }
                      >
                        <Button className="save-changes-disabled-button mt-2">
                          Add Pipeline
                        </Button>
                      </OverlayTrigger>
                    ) : (
                      <Button
                        className="save-changes-button mt-2"
                        onClick={() => dispatch(onAddPipeline())}
                      >
                        Add Pipeline
                      </Button>
                    )}
                    {pipelinePreference && (
                      <Button
                        className="delete-pipeline-button mt-2 ms-3"
                        onClick={() => dispatch(onDeleteSelectedPipeline())}
                      >
                        Clear data
                      </Button>
                    )}
                  </div>
                </Card.Body>
              </Card>

              <Card className="sync-settings-card">
                <Card.Body className="sync-settings-card-body">
                  {cmsInstance &&
                    cmsInstance.showRichText(
                      "cmsContent.invoices.invoiceSyncRules.block2"
                    )}
                  <div className="d-flex flex-row justify-content-between mt-3">
                    <p>
                      <b>On successful invoice creation: </b>
                    </p>
                    <b>
                      <Form.Check
                        type="checkbox"
                        id="addPDF"
                        label="Attach a pdf of invoice in deal"
                        checked={attachPDFToInvoice}
                        onChange={(e) => dispatch(onCheckAddPDF())}
                      />
                    </b>
                  </div>
                </Card.Body>
              </Card>

              <div
                className="d-flex flex-row justify-content-end mb-4"
                style={{ marginTop: "27px" }}
              >
                {selectedPipelines.length === 0 ||
                (pipelinePreference && !dealStagePreference) ? (
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip style={{ fontSize: "12px" }}>
                        {showToolTipText(
                          selectedPipelines,
                          pipelinePreference,
                          dealStagePreference
                        )}
                      </Tooltip>
                    }
                  >
                    <Button className="save-changes-disabled-button">
                      save
                    </Button>
                  </OverlayTrigger>
                ) : (
                  <Button
                    className="save-changes-button"
                    onClick={() =>
                      onSaveInvoiceSyncRules({
                        setIsLoading,
                        dispatch,
                        searchParams,
                        selectedPipelines,
                        attachPDFToInvoice,
                      })
                    }
                  >
                    {isLoading ? (
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      <span>Save</span>
                    )}
                  </Button>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      )}
    </div>
  );
}

export default InvoiceSyncRules;

export const onSaveInvoiceSyncRules = async ({
  setIsLoading,
  dispatch,
  searchParams,
  selectedPipelines,
  attachPDFToInvoice,
}) => {
  try {
    setIsLoading(true);

    const portalId = searchParams.get("portalId");
    await axios.post(getUrl("REACT_APP_SAVE_PREFERENCES"), {
      portalId,
      preferences: {
        triggerSettings: selectedPipelines,
        associateInvoicePdf: {
          association: attachPDFToInvoice,
        },
      },

      preferenceType: "order",
    });
    dispatch(setIsInvoiceSyncRulesSaved());
    dispatch(
      setShowSuccessModal({
        message:
          "cmsContent.notifications.syncSettings.successContent.invoiceSyncRules.message",
      })
    );
  } catch (error) {
    console.log(error);
    let errorMessage;
    if (error.response && error.response.data.message)
      errorMessage = error.response.data.message;
    else errorMessage = error.message;
    console.log(errorMessage);
    dispatch(setShowErrorModal({ message: errorMessage }));
  } finally {
    setIsLoading(false);
  }
};

export const showToolTipText = (
  selectedPipelines,
  pipelinePreference,
  dealStagePreference
) => {
  if (selectedPipelines.length === 0) {
    return "Please select the pipelines";
  } else if (pipelinePreference && !dealStagePreference) {
    return "please select the deal stage to add the pipeline";
  }
};
